export default {
  subject : 'questão',
  email : 'correio eletrônico',
  name : 'nomes',
  message : 'mensaje',
  password: 'senha',
  repeatPassword: 'repita a senha',
  username: 'username',
  country: 'país',
  console: 'console',
  position: 'posição',
  newPassword: 'nova senha',
  passwordConfirmation: 'confirmar nova senha',
  title: 'título',
  idOrUsername: 'id ou o nome',
  period: 'período',
  description: 'descrição',
  videoCode: 'código del video',
  order: 'ordem',
  type: 'tipo',
  teamDowns: 'Number of teams that are down',
  teamLiguilla: 'Número de equipas que vão para os playoffs',
  cardNumber: 'número de cartão',
  cardMonth: 'meses',
  cardYear: 'ano',
}
